import { Text } from '@procurify/ui'
import styled from 'styled-components'

export const SubheadingStyled = styled(Text)`
  color: ${(props) => props.theme.colors.text.secondary};
`
